import React from 'react';

const EmptyDivRenderer = () => <div />;

export default EmptyDivRenderer;
